/* Progressive enhancements; purchasing and checkout use native Shopify forms. */
(() => {
  const triggers = id => Array.from(document.querySelectorAll('[data-toggle]')).filter(el => el.dataset.toggle === id);
  function setPanel(id, open, returnFocus = false) {
    const panel = document.getElementById(id);
    if (!panel) return;
    if (id === 'MainNavigation') panel.classList.toggle('is-open', open);
    else panel.hidden = !open;
    triggers(id).forEach(el => el.setAttribute('aria-expanded', String(open)));
    if (returnFocus) triggers(id)[0]?.focus();
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-toggle]');
    if (toggle) {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      setPanel(toggle.dataset.toggle, open);
    }
    const close = event.target.closest('[data-close]');
    if (close) setPanel(close.dataset.close, false, true);
    if (event.target.closest('#MainNavigation a')) setPanel('MainNavigation', false);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-toggle][aria-expanded="true"]').forEach(el => setPanel(el.dataset.toggle, false, true));
    document.querySelectorAll('.nav-dropdown[open]').forEach(el => { el.open = false; });
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', event.target.value);
      url.hash = '';
      window.location.assign(url.toString());
    }
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-confirm]') && !window.confirm(event.target.dataset.confirm)) event.preventDefault();
  });
  function setupCountries(root = document) {
    root.querySelectorAll('[data-country]').forEach(country => {
      if (country.dataset.initialized) return;
      country.dataset.initialized = 'true';
      if (country.dataset.default) country.value = country.dataset.default;
      const province = document.getElementById(country.dataset.province);
      if (!province) return;
      const update = initial => {
        let rows = [];
        try { rows = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch (_) { rows = []; }
        province.replaceChildren(...rows.map(([value, label]) => new Option(label, value)));
        if (!rows.length) province.append(new Option('Not applicable', ''));
        if (initial && province.dataset.default) province.value = province.dataset.default;
      };
      country.addEventListener('change', () => update(false)); update(true);
    });
  }
  setupCountries();
  document.addEventListener('shopify:section:load', event => setupCountries(event.target));
})();
